import React, { Component } from 'react';
import {
    FormGroup,
    FormControl,
    ControlLabel,
    Panel,
    Button,
    Col,
    Row,
    HelpBlock
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import cyberlogo from '../cyber.jpg';
import config from '../config';
import axios from 'axios';
import DismissableAlert from '../components/DismissableAlert';

class Request2FAReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            isLoading: false,
            success: false,
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            }
        };
    }

    handleChange = (e) => {
        this.setState({ email: e.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ isLoading: true, error: { hidden: true, title: '', message: '', style: 'danger' } });

        axios.post(`${config.baseURL}/auth/request-2fa-reset`, {
            email: this.state.email
        }).then(() => {
            this.setState({ success: true, isLoading: false });
        }).catch(err => {
            this.setState({
                isLoading: false,
                error: {
                    hidden: false,
                    title: 'Error:',
                    message: (err && err.response && err.response.data && err.response.data.message) || 'Something went wrong',
                    style: 'danger'
                }
            });
        });
    };

    render() {
        return (
            <div className="Login">
                <Row>
                    <Col
                        xs={10}
                        sm={6}
                        md={6}
                        lg={4}
                        xsOffset={1}
                        smOffset={3}
                        mdOffset={3}
                        lgOffset={4}
                    >
                        <Panel>
                            <Panel.Body>
                                <a href="https://mysign.uk.com">
                                    <img
                                        src={logo}
                                        alt="logo"
                                        className="center-block img-responsive"
                                        style={{ width: 400, height: 123 }}
                                    />
                                </a>

                                <h4>Request 2FA Reset</h4>
                                <p>If you’ve lost access to your 2FA device, enter your email below. We’ll send a secure link to verify your identity and let you log in.</p>

                                <DismissableAlert
                                    title={this.state.error.title}
                                    message={this.state.error.message}
                                    hidden={this.state.error.hidden}
                                    style={this.state.error.style}
                                />

                                {this.state.success ? (
                                    <HelpBlock className="text-success">
                                        If that email exists, a reset link has been sent.
                                    </HelpBlock>
                                ) : (
                                    <form onSubmit={this.handleSubmit}>
                                        <FormGroup controlId="email">
                                            <ControlLabel>Email Address</ControlLabel>
                                            <FormControl
                                                type="email"
                                                value={this.state.email}
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                        <Button
                                            type="submit"
                                            bsStyle="primary"
                                            disabled={!this.state.email || this.state.isLoading}
                                            block
                                        >
                                            {this.state.isLoading ? 'Sending...' : 'Send Reset Link'}
                                        </Button>
                                    </form>
                                )}
                            </Panel.Body>
                        </Panel>

                        <small style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Link to="/login" style={{ marginRight: '0.5rem' }}>
                                Back to Login
                            </Link>
                        </small>

                        <img
                            src={cyberlogo}
                            alt="cyber logo"
                            className="center-block img-responsive"
                            style={{ width: 400, height: 100 }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Request2FAReset;
